import { $tourDataApi } from '@stores/dataStores';
import type { STImageMarker, STMapMarker } from '@types';

type FiexedMarker = Pick<STMapMarker | STImageMarker, 'id'>[];

export function deleteMarkers({
  sandTableId,
  markerIds,
}: {
  sandTableId: string;
  markerIds: string | Set<string>;
}) {
  let idSet: Set<string>;
  if (typeof markerIds === 'string') {
    idSet = new Set([markerIds]);
  } else {
    idSet = markerIds;
  }

  $tourDataApi.updateSandtable({
    id: sandTableId,
    updater: (draft) => {
      (draft.markers as FiexedMarker) = draft.markers.filter(
        (x) => !idSet.has(x.id)
      );
      const groupList = draft.groupList;
      if (groupList) {
        groupList.forEach((g) => {
          if (g.markers.type === 1) return;
          g.markers.list = g.markers.list.filter((_id) => !idSet.has(_id));
        });
      }
    },
  });
}
